module.exports = __webpack_public_path__ + "static/img/realease-03.1249db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/realease-03.png
// module id = 143
// module chunks = 0